import { ActionCreatorWithPayload } from "@reduxjs/toolkit";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { hasValueWithKeyAsAlign } from "../util/helperFunctions";
import { ChangeEvent } from "react";
import { changeStringValue } from "../../../../store/model";

interface RadioSelectInputProp {
  properyItem: TextShape,
  propertyName: string,
  properyDisplayName: string,
  injection?: ActionCreatorWithPayload<{
    id: string;
    propertyValue: string;
    propertyName: string;
  }>,
}
const RadioSelectInput = ({ properyItem, propertyName, properyDisplayName, injection }: RadioSelectInputProp) => {

  const toolSettings = useAppSelector((state) => state.tool.toolSettings)
  const dispatch = useAppDispatch();

  return (
    <div>
      <p>
        {toolSettings.text.aligmentOptions.map((mode) => {
          return (
            <label key={mode} >
              <input
                type="radio"
                name={"radioSelect" + properyItem.id}
                value={mode}
                defaultChecked={
                  mode === hasValueWithKeyAsAlign(properyItem, propertyName)
                }
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  dispatch(changeStringValue({ id: properyItem.id, propertyValue: e.target.value, propertyName: propertyName }))
                }}
              />
              {mode}
            </label>
          )
        }
        )}
      </p>
    </div>
  )
}


export default RadioSelectInput;